import GoogleMapReact from "google-map-react";
import React, { PropsWithChildren, useContext, useEffect } from "react";
import AirbnbMarker from "./Icons/AirbnbMarker";
import HotelMarker from "./Icons/HotelMarker";
import SelectedAirbnbMarker from "./Icons/SelectedAirbnbMarker";
import SelectedHotelMarker from "./Icons/SelectedHotelMarker";
import SelectedStoreMarker from "./Icons/SelectedStoreMarker";
import StoreMarker from "./Icons/StoreMarker";
import CompetitorMarker from "./Icons/CompetitorMarker";
import { MapContext } from "./MapContext";

const styles = [
  {
    featureType: "water",
    clickableIcons: false,
    elementType: "geometry",
    stylers: [
      {
        color: "#e9e9e9",
      },
      {
        lightness: 17,
      },
    ],
  },
  {
    featureType: "landscape",
    clickableIcons: false,
    elementType: "geometry",
    stylers: [
      {
        color: "#f5f5f5",
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: "road.highway",
    clickableIcons: false,
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#ffffff",
      },
      {
        lightness: 17,
      },
    ],
  },
  {
    featureType: "road.highway",
    clickableIcons: false,
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#ffffff",
      },
      {
        lightness: 29,
      },
      {
        weight: 0.2,
      },
    ],
  },
  {
    featureType: "road.arterial",
    clickableIcons: false,
    elementType: "geometry",
    stylers: [
      {
        color: "#ffffff",
      },
      {
        lightness: 18,
      },
    ],
  },
  {
    featureType: "road.local",
    clickableIcons: false,
    elementType: "geometry",
    stylers: [
      {
        color: "#ffffff",
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    featureType: "poi",
    clickableIcons: false,
    elementType: "geometry",
    stylers: [
      {
        color: "#f5f5f5",
      },
      {
        lightness: 21,
      },
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "poi.park",
    clickableIcons: false,
    elementType: "geometry",
    stylers: [
      {
        color: "#dedede",
      },
      {
        lightness: 21,
      },
    ],
  },
  {
    elementType: "labels.text.stroke",
    clickableIcons: false,
    stylers: [
      {
        visibility: "off",
      },
      {
        color: "#ffffff",
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    elementType: "labels.text.fill",
    clickableIcons: false,
    stylers: [
      {
        saturation: 36,
      },
      {
        color: "#333333",
      },
      {
        lightness: 40,
      },
    ],
  },
  {
    elementType: "labels.icon",
    clickableIcons: false,
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "transit",
    clickableIcons: false,
    elementType: "geometry",
    stylers: [
      {
        color: "#f2f2f2",
      },
      {
        lightness: 19,
      },
    ],
  },
  {
    featureType: "administrative",
    clickableIcons: false,
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#fefefe",
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: "administrative",
    clickableIcons: false,
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#fefefe",
      },
      {
        lightness: 17,
      },
      {
        weight: 1.2,
      },
    ],
  },
];

export const MapComponent = (props: PropsWithChildren<any>) => {
  const {
    stores,
    coords,
    setSortCoords,
    currentStore,
    setCurrentStore,
    defaultZoom,
    setDefaultZoom,
  } = useContext(MapContext);

  return (
    // Important! Always set the container height explicitly
    <div style={{ height: "100vh", width: "100%" }}>
      <GoogleMapReact
        ref={props.mapRef}
        bootstrapURLKeys={{ key: "AIzaSyDu38iTBz3xKFM8-xnluvYvzuPNFR6fylc" }}
        center={coords}
        options={{ styles, disableDefaultUI: true, clickableIcons: false }}
        onDragEnd={(map) =>
          setSortCoords({
            lat: map.getCenter().lat(),
            lng: map.getCenter().lng(),
          })
        }
        zoom={defaultZoom}
        onZoomAnimationEnd={(e) => {
          setDefaultZoom(e);
          console.log(e);
        }}>
        {stores.map((store, i) => {
          switch (store.business_type) {
            case "airbnb":
              if (currentStore?.id === store.id) {
                return (
                  <SelectedAirbnbMarker
                    lat={store.latitude}
                    lng={store.longitude}
                    onClick={() => {
                      setCurrentStore(store);
                      props.openStore();
                    }}
                  />
                );
              } else {
                return (
                  <AirbnbMarker
                    lat={store.latitude}
                    lng={store.longitude}
                    onClick={() => {
                      setCurrentStore(store);
                      props.openStore();
                    }}
                  />
                );
              }
            case "hotel":
              if (currentStore?.id === store.id) {
                return (
                  <SelectedHotelMarker
                    lat={store.latitude}
                    lng={store.longitude}
                    onClick={() => {
                      setCurrentStore(store);
                      props.openStore();
                    }}
                  />
                );
              } else {
                return (
                  <HotelMarker
                    lat={store.latitude}
                    lng={store.longitude}
                    onClick={() => {
                      setCurrentStore(store);
                      props.openStore();
                    }}
                  />
                );
              }
            case "competitor":
              return (
                <CompetitorMarker
                  lat={store.coords.lat ? store.coords.lat : 0}
                  lng={store.coords.lng ? store.coords.lng : 0}
                  onClick={() => {}}
                />
              );
            default:
              if (currentStore?.id === store.id) {
                return (
                  <SelectedStoreMarker
                    lat={store.latitude}
                    lng={store.longitude}
                    onClick={() => {
                      setCurrentStore(store);
                      props.openStore();
                    }}
                  />
                );
              } else {
                return (
                  <StoreMarker
                    lat={store.latitude}
                    lng={store.longitude}
                    show={false}
                    onClick={() => {
                      setCurrentStore(store);
                      props.openStore();
                    }}
                  />
                );
              }
          }
        })}
      </GoogleMapReact>
    </div>
  );
};
